<div class="bn-care-plan-panel flex flex-col gap-4">
  <div
    class="bn-care-plan-panel__header flex items-center justify-between gap-3"
  >
    <h2 class="bn-care-plan-panel__title m-0">Care Plan</h2>
    <div class="bn-care-plan-panel__actions">
      <button
        type="button"
        data-testid="add-client-action"
        class="bn-care-plan-panel__open-case"
        [disabled]="addActionLoading() || !!addActionDisabledReason()"
        [attr.aria-describedby]="
          addActionNotice() ? 'bn-add-action-disabled-reason' : null
        "
        [title]="addActionNotice() ?? 'Add action'"
        (click)="caseList()?.openAddAction()"
      >
        + Add action
      </button>
      <button
        type="button"
        class="bn-care-plan-panel__open-case"
        [disabled]="!!openCaseDisabledReason()"
        [attr.aria-describedby]="
          openCaseNotice() ? 'bn-open-case-disabled-reason' : null
        "
        [title]="openCaseNotice() ?? 'Open a case'"
        data-testid="open-case"
        (click)="openCaseDialog()"
      >
        + Open a case
      </button>
    </div>
    <button
      type="button"
      class="bn-care-plan-panel__open-case bn-care-plan-panel__menu-toggle"
      aria-label="Care Plan actions"
      aria-haspopup="menu"
      aria-controls="care-plan-actions-menu"
      [attr.aria-expanded]="actionMenuOpen()"
      (click)="actionsMenu.toggle($event)"
    >
      <i class="pi pi-bars" aria-hidden="true"></i>
    </button>
  </div>
  <p-menu
    #actionsMenu
    id="care-plan-actions-menu"
    [model]="actionMenuItems()"
    [popup]="true"
    appendTo="body"
    ariaLabel="Care Plan actions"
    (onShow)="actionMenuOpen.set(true)"
    (onHide)="actionMenuOpen.set(false)"
  />

  @if (store.goalsEnabled() && store.isLive()) {
    @if (store.goalsLoading() && !store.goalsLoaded()) {
      <div
        role="status"
        aria-label="Loading client goals"
        data-testid="goals-skeleton"
        class="flex items-center gap-3 rounded-xl border border-primary-100 p-3 min-w-0"
      >
        <p-skeleton width="4rem" height="1rem" />
        <p-skeleton
          class="flex-1 min-w-0"
          width="100%"
          height="1.75rem"
          borderRadius="1rem"
        />
        <p-skeleton
          class="flex-1 min-w-0"
          width="100%"
          height="1.75rem"
          borderRadius="1rem"
        />
      </div>
    } @else if (store.goalsError(); as message) {
      <div role="alert" class="text-sm flex items-center gap-3">
        <span>{{ message }}</span>
        <button
          type="button"
          (click)="retryGoals()"
          [disabled]="store.goalsSaving()"
        >
          Retry goals
        </button>
      </div>
    } @else if (store.goalsLoaded()) {
      <bn-goals-bar (manageGoals)="openManageGoals()" />
    }
  }

  @if (addActionNotice(); as reason) {
    <div
      id="bn-add-action-disabled-reason"
      class="text-sm text-surface-600"
      role="status"
    >
      {{ reason }}
    </div>
  }

  @if (openCaseNotice(); as reason) {
    <div
      id="bn-open-case-disabled-reason"
      class="text-sm text-surface-600"
      role="status"
    >
      {{ reason }}
    </div>
  }

  @if (store.isLive()) {
    @if (store.domainError(); as error) {
      <div class="bn-care-plan-panel__error text-sm" role="alert">
        {{ error }}
        <button
          type="button"
          class="bn-care-plan-panel__open-case"
          (click)="store.loadDomains(true)"
        >
          Retry domains
        </button>
      </div>
    }
  }

  @if (store.loadWarning(); as warning) {
    <div class="text-sm text-surface-600" role="status">
      {{ warning }}
    </div>
  }

  @if (store.loading()) {
    <div
      class="bn-care-plan-panel__skeleton flex flex-col gap-3"
      role="status"
      aria-label="Loading care plan"
    >
      <p-skeleton height="1.75rem" width="12rem" />
      <p-skeleton height="4rem" />
      <p-skeleton height="4rem" />
      <p-skeleton height="4rem" />
    </div>
  } @else if (store.error(); as error) {
    <div
      class="bn-care-plan-panel__error flex flex-col items-center gap-2 text-center py-10"
      role="alert"
    >
      <i
        class="pi pi-exclamation-circle text-2xl text-surface-400"
        aria-hidden="true"
      ></i>
      <p class="m-0">{{ error.message }}</p>
      @if (store.isLive()) {
        <button
          type="button"
          class="bn-care-plan-panel__open-case"
          (click)="store.retryLive()"
        >
          Retry
        </button>
      }
    </div>
  } @else {
    <bn-case-list />
  }
</div>
